export default __webpack_public_path__ + "static/media/add-image.55460925.svg";